import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '1',
    title: '20 Creativos con IA',
    description: 'Imágenes publicitarias con tu marca y el texto ya integrado (headline + CTA renderizados de forma nativa, no pegados encima), generadas según tu nicho. Listas para descargar y publicar.',
    value: 'USD 47',
    image: 'https://cdn.magicpatterns.com/uploads/twameapDEY6rDNecZjs16K/BONO_1.png'
  }, {
    number: '2',
    title: 'Biblioteca de Copy que vende',
    description: '100 titulares, 30 estructuras de anuncio y decenas de CTAs, escritos por IA para tu negocio. Copiás, pegás y listo.',
    value: 'USD 37',
    image: 'https://cdn.magicpatterns.com/uploads/6ULgNBVTBevH1xrXbnraYU/BONO_2.png'
  }, {
    number: '3',
    title: 'Mapa de Segmentación',
    description: 'Públicos, intereses y demografía sugeridos para tus campañas de Meta — para dejar de tirar al aire y saber a quién impactar.',
    value: 'USD 27',
    image: 'https://cdn.magicpatterns.com/uploads/omnkfYDtfkXW6CZLLpUo7c/BONO_3.png'
  }, {
    number: '4',
    title: 'Calculadora de Presupuesto y ROAS',
    description: 'Simulá cuánto invertir, tu punto de equilibrio y si la campaña va a dar ganancia antes de gastar un peso.',
    value: 'USD 19',
    image: 'https://cdn.magicpatterns.com/uploads/fdsuaTCPgx8jcTP5rVX7px/BONO_4.png'
  }, {
    number: '5',
    title: 'Checklist "Campaña en 1 día"',
    description: 'El paso a paso exacto, con tu progreso guardado, desde el brief hasta lanzar. Cuando lo completás, ya estás listo para vender.',
    value: 'USD 15',
    image: 'https://cdn.magicpatterns.com/uploads/1XuUivFqLr8DB9351jWaeX/BONO_5.png'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-7">
      <div className="max-w-4xl mx-auto px-4" data-id="element-8">
        <div className="text-center mb-12" data-id="element-9">
          <div className="inline-flex items-center gap-2 bg-green-100 text-green-800 px-4 py-2 rounded-full font-bold text-sm mb-6" data-id="element-10">
            <Gift className="w-4 h-4" data-id="element-11" />
            BONOS GRATIS INCLUIDOS
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-12">
            Además del sistema, te llevás estas herramientas
          </h2>
          <p className="text-lg text-slate-600" data-id="element-13">
            Todas dentro de la plataforma:
          </p>
        </div>

        <div className="space-y-6" data-id="element-14">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`bg-white rounded-2xl p-6 md:p-8 shadow-sm border border-slate-200 flex flex-col gap-6 items-center md:items-center ${index % 2 === 1 ? 'md:flex-row-reverse' : 'md:flex-row'}`} data-id="element-15">
              {/* Mockup del bono */}
              <div className="w-48 md:w-56 flex-shrink-0" data-id="element-16">
                <img src={bonus.image} alt={`Bono ${bonus.number}: ${bonus.title}`} loading="lazy" className="w-full h-auto drop-shadow-xl" data-id="element-17" />
              </div>

              <div className="flex-1 text-center md:text-left" data-id="element-18">
                <div className="inline-flex items-center gap-2 bg-blue-600 text-white px-3 py-1 rounded-full text-xs font-black mb-3 shadow-lg shadow-blue-600/30" data-id="element-19">
                  <Gift className="w-3.5 h-3.5" data-id="element-20" />
                  BONO #{bonus.number}
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-3" data-id="element-21">
                  {bonus.title}
                </h3>
                <p className="text-slate-600 mb-4 leading-relaxed" data-id="element-22">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-3 bg-slate-50 inline-flex px-4 py-2 rounded-lg border border-slate-100" data-id="element-23">
                  <span className="text-slate-500 text-sm" data-id="element-24">Valor:</span>
                  <span className="text-slate-400 line-through font-medium" data-id="element-25">
                    {bonus.value}
                  </span>
                  <span className="text-green-600 font-bold" data-id="element-26">GRATIS</span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <div className="mt-12 text-center bg-blue-50 rounded-2xl p-8 border border-blue-100" data-id="element-27">
          <p className="text-lg text-slate-700 mb-2" data-id="element-28">
            Estos bonos valen USD 145 — hoy van incluidos
          </p>
          <p className="text-3xl font-black text-green-600 mb-2" data-id="element-29">GRATIS</p>
        </div>
      </div>
    </section>;
}